"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconChevronLeft = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "-4 0 24 19",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      points: "12.51 1.87 10.73 0.1 0.84 10 10.74 19.9 12.51 18.13 4.38 10"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconChevronLeft')(IconChevronLeft);